import * as React from 'react'

import { cn } from '@/lib/utils'

function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'flex h-10 w-full min-w-0 rounded-md border border-input bg-white/[0.035] px-3.5 text-sm shadow-soft transition-[box-shadow,border-color,background-color] duration-150 ease-out',
        'placeholder:text-muted-foreground/80',
        'selection:bg-primary/15 selection:text-foreground',
        'file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground',
        'outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/30',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
        'hover:bg-white/[0.055]',
        'md:text-sm',
        className,
      )}
      {...props}
    />
  )
}

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'flex min-h-20 w-full rounded-md border border-input bg-white/[0.035] px-3.5 py-2.5 text-sm shadow-soft transition-[box-shadow,border-color,background-color] duration-150 ease-out',
        'placeholder:text-muted-foreground/80',
        'outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/30',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20',
        'hover:bg-white/[0.055]',
        className,
      )}
      {...props}
    />
  )
}

export { Input, Textarea }
